module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close_today":"Do not show again today"}}')
  delete Component.options._Ctor
}
